import React, { useState } from 'react';
import { Table, Modal, Button, Form } from 'react-bootstrap';
import "react-datepicker/dist/react-datepicker.css";
import Spinner1 from '../common/spinners';
import { truncateText } from "../../utils/utilities";
import moment from 'moment';
import PaymentHistoryModal from '../modals/PaymentHistoryModal';
import LabRequestHistoryModal from '../modals/LabRequestHistoryModal';
import { FullscreenIcon } from 'lucide-react';
import { useDashboard } from '../../context/dashboardContext';


const RadiologyTable = () => {

   const {appointments:data, loading, handleFetAppointments, handleReScheculeAppointment,showDetailsModal, setShowDetailsModal, setConfirmModal, confirmModal, handleCancelAppointment}= useDashboard();
     
  const [searchTerm, setSearchTerm] = useState('');
  const [showSummaryModal, setShowSummaryModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const [selectedData, setSelectedData] = useState()
  const [selectedLab, setSelectedLab] = useState(null);
  const [show, setShow] = useState(false);

 

   // Open Modal and Set Data
   const openDetailsModal = (item) => {
    setSelectedData(item);
    setShowSummaryModal(true);
  };

 

//search filter
  const filteredData = data?.filter(
    (lab) =>
      lab?.item?.labTest?.name?.toLowerCase().includes(searchTerm.toLowerCase()) //||
      // item?.description?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredData?.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData?.slice(indexOfFirstItem, indexOfLastItem);

  const openModal = (lab) => {
    setSelectedLab(lab);
    setShow(true);
  };
  const handleClose = () => {
    setShow(false);
    setSelectedLab(null);
  };

// console.log(data)
  return (
    <div id='radiology' className=' w-100'>
      <Form.Control
        type="text"
        placeholder="Search..."
        className="my-3 mx-4"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ width: '250px' }}
      />
      {
         loading ? <div className=' w-100 d-flex justify-content-center'><Spinner1/></div> : 
         !loading && !filteredData?.length?
         <div className=' w-100 d-flex justify-content-center text-center pb-4'>No Result Found!</div> :

         <div style={{overflowX:'auto'}}>
          <table style={{minWidth:'600px'}}  striped hover className="align-middle w-100">
            {/* Table Header */}
            <thead className=' px-3'>
              <tr className=' px-3'>
                <th  style={{ paddingLeft: '20px' }}>Lab Investigation</th>
                {/* <th>Consultant</th> */}
                <th>Specimen</th>
                <th>Amount</th>
                {/* <th>Approved By</th> */}
                {/* <th>Comment</th> */}
                <th>Status</th>
              </tr>
            </thead>

            {/* Table Body */}
            <tbody className=' px-5'>
              { 
              
              currentItems?.map((item, index) => (
                <tr 
                  key={index} 
                  // onClick={() => openDetailsModal(item)} 
                // onClick={() => openSummaryModal(item)}
                  className="py-3 border-bottom" 
                  style={{ cursor: 'pointer', height: '65px' }} 
                >
                  <td className="py-3 px-3">
                    <div className="d-flex align-items-center gap-2">
                      <div className="avatar border border-2 border-success text-info d-flex justify-content-center align-items-center">
                        <i className="ri-information-line"></i>
                      </div>
                      <div className="mb-0">
                        <h6 className="d-block text-primary fs-sm mb-1 text-capitalize">{truncateText(`${item?.item?.labTest?.name}`, 40)}</h6>
                        <label className='fs-xs' >{moment(item?.createdAt).format("dddd, Do MMMM, YYYY")}</label>
                      </div>
                    </div>
                  </td>

                  <td>
                  <div className="d-flex align-items-center gap-2">
                      <div>
                        <div className="mb-0 small">{item?.item?.labTest?.specimens?.map((item)=>(
                          <h6 className='mb-0 text-capitalize' key={item}>{item.label}</h6>
                        ))}</div>
                        <span className="fs-xs text-success">
                          { moment(item?.item?.labTest?.createdAt).format("dddd, Do MMM YYYY")}
                        </span>
                      </div>
                    </div>
                  </td>
                  <td className="py-3">
                    <div className="d-flex align-items-center gap-2">
                        <div>
                          <h6 className="mb-0 text-secondary">{item?.item?.transaction?.amount.toLocaleString("en-NG", { style: "currency", currency: "NGN" })}</h6>
                          <span className="fs-xs text-danger">
                            {item?.item?.transaction?.description ? (truncateText(`${item?.item?.transaction?.description}`, 20)||""``) : "No description"}   
                          </span>
                        </div>
                      </div>
                  </td>
                  {/* <td className="py-3">
                    <div>
                        <h6 className='text-capitalize'>
                          
                      {truncateText(`${item?.item?.approvedBy ?? "---"}`, 15)}
                        </h6>
                        <span className='text-primary fs-xs'>{moment(item?.item?.approvedAt?? "---").format("Do MMM YYYY")}</span>
                    </div>
                  </td> */}
                  <td className="py-3 text-capitalize">
                  <td>
                  {/* <span className="badge bg-primary">completed</span> */}
                  {
                    item?.status === 0 ? <span className="badge bg-warning text-secondary">Awaiting <br/> Payment</span> : <span className="badge bg-primary">completed</span>
                  }
                </td>

                  </td>
                  <td className="text-success" style={{ cursor: 'pointer' }}>
                  {
                        item?.status ===1 && (
                          <FullscreenIcon onClick={() => openModal(item)} /> 
                        )
                      }
                  </td>
                
                </tr>
              ))} 
            </tbody>
          </table>
{/* Centralized Modal */}
      <Modal size='lg' show={show} onHide={handleClose}  scrollable centered>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          {selectedLab ? (
            <div className=' w-100'>
              <ul style={{listStyleType:'none'}}>
                <li className=' mb-4'>Title: <span>{selectedLab?.item?.labTest?.name}</span></li>
                {/* <li>Results</li> */}
                <Table>
                  <thead>
                    <th>Parameter</th>
                    <th>Value</th>
                    <th>Reference</th>
                    {/* <th>Inference</th> */}
                  </thead>
                  <tbody>
                   
                  {
                    selectedLab?.item?.parameters?.map((x)=>(
                      <tr key={x?.id}>
                        <td>{x?.name}</td>
                        <td>{x?.value}</td>
                        <td>{x?.reference}</td>
                        {/* <td></td> */}
                      </tr>
                    ))
                  }
                  </tbody>
                </Table>
              </ul>
            </div>
          ) : (
            "No data available"
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Close</Button>
        </Modal.Footer>
      </Modal>
         </div>

      }
      {
        !loading && filteredData?.length? (
      <div className="d-flex justify-content-between align-items-center mt-3">
          <Button
          variant="light"
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(currentPage - 1)}
          >
          Previous
          </Button>
          <span>Page {currentPage} of {totalPages}</span>
          <Button
          variant="light"
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage(currentPage + 1)}
          >
          Next
          </Button>
      </div>
        ) : null
      }

      {/* modal details */}
      <LabRequestHistoryModal
        show={showSummaryModal} 
        onClose={() => setShowSummaryModal(false)}
        data = {selectedData}
      />

    </div>
  );
};
export default RadiologyTable;